import { useEffect, useRef } from 'react';

import SimpleBarCore from 'simplebar-core';

export default function useSimpleBar() {
  const simplebarRef = useRef<SimpleBarCore>(null);

  useEffect(() => {
    simplebarRef?.current?.recalculate();
  });

  return [simplebarRef];
}
